import React, { Fragment } from 'react'

import { onEnter } from '../../../utilities/accessibility/onEnter'

const BkFlowRoomCardDescriptionAccordion = props => {
	const {
		hotelLabels,
		roomDescription,
		roomDescriptionExpanded,
		roomData,
		limitChars,
		roomDescriptionEvent
	} = props

	return (
		<p className={
			roomData.viewExtensions &&
			roomData.viewExtensions.adaDetails ?
				'bk-flow-room__card-description__paragraph inc-ada'
			: 'bk-flow-room__card-description__paragraph'
		}>
			{ roomDescription.length > limitChars ?
				<Fragment>
					{ roomDescription.slice(0, limitChars) }
					<span className={ roomDescriptionExpanded ? 'u-txt-read-more expanded' : 'u-txt-read-more' }>{ roomDescription.slice(limitChars) }</span>
					<span
						onClick={ roomDescriptionEvent }
						className="u-txt-toggle-read-more u-font-small u-font-bold"
						onKeyDown={event => onEnter(event, roomDescriptionEvent)}
						role="button"
						tabIndex="0"
					>
						{ roomDescriptionExpanded ? '... ' + hotelLabels.readLess : '... ' + hotelLabels.readMore }
					</span>
				</Fragment>
			:
				roomDescription
			}
		</p>
	)
}

export default BkFlowRoomCardDescriptionAccordion


// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardDescriptionAccordion.js